// Lightweight metadata file - always bundled (no translation strings)
// The actual translations are lazy-loaded from translations.ts

export const languages = ['en', 'es', 'de', 'fr', 'nl', 'it', 'pt', 'dk'] as const;
export type Language = (typeof languages)[number];

export const languageNames: Record<Language, string> = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  nl: 'Nederlands',
  it: 'Italiano',
  pt: 'Português',
  dk: 'Dansk',
};

export const languageFlags: Record<Language, string> = {
  en: '🇬🇧',
  es: '🇪🇸',
  de: '🇩🇪',
  fr: '🇫🇷',
  nl: '🇳🇱',
  it: '🇮🇹',
  pt: '🇵🇹',
  dk: '🇩🇰',
};
